import { render, staticRenderFns } from "./userView.vue?vue&type=template&id=664ce912&scoped=true&"
import script from "./userView.vue?vue&type=script&lang=js&"
export * from "./userView.vue?vue&type=script&lang=js&"
import style0 from "./userView.vue?vue&type=style&index=0&id=664ce912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ce912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VFlex,VIcon,VLayout,VPagination,VSelect,VSimpleTable})
